module.exports = __webpack_public_path__ + "assets/img/D-1e839b1e.png";